import React from 'react';
import {
    List,
    ListProps,
    TextField,
    BooleanInput,
    Filter,
    TextInput,
    SelectInput,
    Pagination,
    downloadCSV,
    AutocompleteArrayInput
} from 'react-admin';
import {Link, useLocation} from 'react-router-dom';

import ProjectsData from '../ProjectsData';

import styles from './styles.module.scss';
import Breadcrumb from "~components/Breadcrumb";
import i18next from "i18next";
import Toggle from 'react-toggle';
import "react-toggle/style.css";
import OldBreadcrumb from '~components/OldBreadcrumb';
import MapToggle from '~components/MapToggle';

// eslint-disable-next-line react/no-multi-comp
const PostPagination = props => {
    return <Pagination rowsPerPageOptions={[25, 50, 100]}  {...props} />;
};
//
// export const financingChoices = [
//     {id: 'public_project', name: 'Público'},
//     {id: 'private_project', name: 'Privado'},
//     {id: 'mixed_project', name: 'Mixto'}
// ];
//
// function formatProject(p) {
//     delete p.starredAt;
//     // delete p.kmlSimplified;
//     delete p.dynamicMapZoom;
//     delete p.staticMapZoom;
//     delete p.dynamicCenterLatitude;
//     delete p.dynamicCenterLongitude;
//     delete p.dynamicCenter;
//     delete p.staticCenter;
//     delete p.projectType;
//     delete p.sources;
//     delete p.editable;
//     delete p.createdDate;
//     delete p.updatedDate;
//     delete p.totalInvestment;
//     delete p.galleryItems;
//     delete p.link;
//
//     p.Sector = p.iirsaSector.name;
//     delete p.iirsaSector;
//
//     p.Subsector = p.iirsaSubsector.name;
//     delete p.iirsaSubsector;
//
//     p.Etapa = p.iirsaStage.name;
//     delete p.iirsaStage;
//
//     p.Estado = p.iirsaStatus.name;
//     delete p.iirsaStatus;
//
//     p.Alcance = p.iirsaScope.name;
//     delete p.iirsaScope;
//
//     p.Tipo_de_Obra = p.iirsaProjectType ? p.iirsaProjectType.name : '';
//     delete p.iirsaProjectType;
//
//     p.Estado_de_los_Estudios = p.iirsaStudiesState ? p.iirsaStudiesState.name : '';
//     delete p.iirsaStudiesState;
//
//     p.Financiador_de_los_Estudios = p.iirsaStudiesFunder ? p.iirsaStudiesFunder.name : '';
//     delete p.iirsaStudiesFunder;
//
//     // let elements = p.iirsaProjectFunding;
//     // if (elements && elements.length > 0) {
//     //     for(let i = 0; i <  elements.length; i++) {
//     //         const prefix = 'FINANCIAMIENTO_' + (i + 1).toString() + '_';
//     //         p[prefix + 'MONTO'] = elements[i].amount;
//     //         p[prefix + 'TIPO'] = elements[i].fundingType ? elements[i].fundingType.name : "";
//     //         p[prefix + 'FINANCIADOR'] = elements[i].funder ? elements[i].funder.name : "";
//     //         p[prefix + 'ESTADO'] = elements[i].fundingStatus ? elements[i].fundingStatus.name : "";
//     //     }
//     // }
//     // delete p.iirsaProjectFunding;
//     delete p.iirsaSegments;
//     delete p.iirsaLink;
//     delete p.iirsaCountries;
// }
//
// const exporter = proj => {
//     const page = proj?.page || [];
//     page.forEach(p => {
//         formatProject(p);
//     });
//     const formattedCsv = parse(proj);
//     downloadCSV(formattedCsv, 'Proyectos');
// };

interface CustomListProps extends ListProps {
    mapPath: string;
    listPath: string;
    listLabel: string;
    chartsPath: string;
    chartsLabel: string;
    title: string;
    breadcrumb?: React.Component;
}

const CustomList: React.FC<CustomListProps> = (props) => {
    const location = useLocation();
    const {
        mapPath,
        listPath,
        listLabel,
        chartsPath,
        chartsLabel,
        title,
        breadcrumb,
        ...restProps
    } = props;

    const mapPathWithQuery = mapPath ? `${mapPath}${location.search}` : null;
    
    return (
        <>
            <div className={styles.listContainer}>
                <div className={styles.listHeader}>
                    <div className={styles.header}>
                        {mapPathWithQuery ? 
                            <MapToggle defaultChecked={false} listPath={mapPathWithQuery}/>
                            : <></>}
                        {breadcrumb || <OldBreadcrumb paths={[
                            {name: i18next.t('projects-iirsa:start')},
                            {name: i18next.t('projects-iirsa:countries')},
                        ]} title={title}/>}
                        <ProjectsData {...restProps} />
                    </div>
                </div>
                <div className={styles.listContent}>
                    <div className={styles.list}>
                        {restProps.children}
                    </div>
                </div>
            </div>
        </>
    );
}

export default CustomList;
